







ENV = require "config/env"
FUNCTIONS = require "scripts/common"
module.exports =
	computed:
		primaryNav: -> return ENV.primaryNav
		isEnglish: -> return FUNCTIONS.judgeIsEnglish(this.$route)
		pageName: -> return this.$route.name
		toEn: ->
			return {
				name: "en_"+this.$route.name.replace("en_","")
				params: this.$route.params
			}
		toJa: ->
			return {
				name: this.$route.name.replace("en_","")
				params: this.$route.params
			}

	methods:
		renderText: (text) -> return if !this.isEnglish then text.ja else text.en
		to: (link) ->
			if this.isEnglish then return {name: "en_"+link.name, params: link.params}
			return {name: link.name, params: link.params}
		isActive: (link) ->
			if this.pageName.replace("en_","") is "about"
				return this.$route.params.projectName is link.params.projectName
			if this.pageName.replace("en_","") is "posts" or this.pageName.replace("en_","") is "post"
				if this.$route.params.projectName isnt "all"
					return this.$route.params.projectName is link.params.projectName
			if this.pageName.replace("en_","") is "publications" or this.pageName.replace("en_","") is "publication"
				return this.pageName.replace("en_","").replace("s","") is link.name.replace("s","")
			this.pageName.replace("en_","") is link.name
		toClass: (label) ->
			switch label
				when "Supervision" then return "supervision"
				when "Project 01" then return "project01"
				when "Project 02" then return "project02"
				when "Project 03" then return "project03"
			return ""



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/primaryNav.vue